import { render } from "./characterLimit.vue?vue&type=template&id=bdbe6acc"
import script from "./characterLimit.vue?vue&type=script&lang=js"
export * from "./characterLimit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__